import { useEffect, useState, useRef } from 'react';

export default function AppInside() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-b from-[#f8f7f6] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 sm:w-64 sm:h-64 bg-[#e77e23] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 sm:w-64 sm:h-64 bg-[#e77e23] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-4">
            Uygulama İçinden
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Kullanıcı dostu arayüz ile kolay ve hızlı işlem deneyimi
          </p>
        </div>

        <div className="relative flex items-center justify-center gap-4 sm:gap-8 overflow-hidden px-4">
          {/* Left Phone - İlan Oluştur — mobile'da gizli, orta telefon tek basina */}
          <div
            className={`relative transform scale-75 sm:scale-90 transition-all duration-700 hidden sm:block ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'
            }`}
          >
            <div className="w-40 h-[320px] sm:w-56 sm:h-[450px] lg:w-64 lg:h-[520px] bg-black rounded-[2rem] sm:rounded-[3rem] p-2 sm:p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img
                  src="/images/app-inside-1.webp"
                  alt="İlan Oluştur"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Center Phone - Duyuru/Etkinlik Oluştur (Larger) */}
          <div
            className={`relative z-10 transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
            }`}
          >
            <div className="w-48 h-[380px] sm:w-64 sm:h-[520px] lg:w-72 lg:h-[580px] bg-gray-800 rounded-[2rem] sm:rounded-[3rem] p-2 sm:p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img
                  src="/images/app-inside-2.webp"
                  alt="Duyuru Oluştur"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Right Phone - Acil Yardım — mobile'da gizli */}
          <div
            className={`relative transform scale-75 sm:scale-90 transition-all duration-700 delay-400 hidden sm:block ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'
            }`}
          >
            <div className="w-40 h-[320px] sm:w-56 sm:h-[450px] lg:w-64 lg:h-[520px] bg-black rounded-[2rem] sm:rounded-[3rem] p-2 sm:p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                <img
                  src="/images/app-inside-3.webp"
                  alt="Acil Yardım"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}